import * as timesheetTypes from "../../types/admin/timesheetTypes";

export const saveUserLateTimeReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case timesheetTypes.SAVE_USER_LATE_TIME_REQUEST:
      return {
        ...state,
        saveUserLateTimeLoading: true,
      };
    case timesheetTypes.SAVE_USER_LATE_TIME_SUCCESS:
      return {
        ...state,
        saveUserLateTimeLoading: false,
        saveUserLateTimeInfo: payload,
        saveUserLateTimeError: "",
      };
    case timesheetTypes.SAVE_USER_LATE_TIME_FAIL:
      return {
        ...state,
        saveUserLateTimeLoading: false,
        saveUserLateTimeInfo: [],
        saveUserLateTimeError: payload,
      };
    default:
      return state;
  }
};

export const getAllLateTimeReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case timesheetTypes.GET_ALL_LATE_TIME_REQUEST:
      return {
        ...state,
        getAllLateTimeLoading: true,
      };
    case timesheetTypes.GET_ALL_LATE_TIME_SUCCESS:
      return {
        ...state,
        getAllLateTimeLoading: false,
        getAllLateTimeInfo: payload,
        getAllLateTimeError: "",
      };
    case timesheetTypes.GET_ALL_LATE_TIME_FAIL:
      return {
        ...state,
        getAllLateTimeLoading: false,
        getAllLateTimeInfo: [],
        getAllLateTimeError: payload,
      };
    default:
      return state;
  }
};

export const shiftToCheckinReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case timesheetTypes.SHIFT_TO_CHECKIN_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case timesheetTypes.SHIFT_TO_CHECKIN_SUCCESS:
      return {
        ...state,
        loading: false,
        shiftToCheckin: payload,
        error: "",
      };
    case timesheetTypes.SHIFT_TO_CHECKIN_FAIL:
      return {
        ...state,
        loading: false,
        shiftToCheckin: [],
        error: payload,
      };
    default:
      return state;
  }
};

export const overtimeSettingsEnableReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case timesheetTypes.OVERTIME_SETTINGS_ENABLE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case timesheetTypes.OVERTIME_SETTINGS_ENABLE_SUCCESS:
      return {
        ...state,
        loading: false,
        overtimeSettingsInfo: payload,
        error: "",
      };
    case timesheetTypes.OVERTIME_SETTINGS_ENABLE_FAIL:
      return {
        ...state,
        loading: false,
        overtimeSettingsInfo: [],
        error: payload,
      };
    default:
      return state;
  }
};

export const getOvertimeSettingsReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case timesheetTypes.GET_OVERTIME_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case timesheetTypes.GET_OVERTIME_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        overtimeSettingsInfo: payload,
        error: "",
      };
    case timesheetTypes.GET_OVERTIME_SETTINGS_FAIL:
      return {
        ...state,
        loading: false,
        overtimeSettingsInfo: [],
        error: payload,
      };
    default:
      return state;
  }
};
